import React from "react";
import PolicyTermsPage from "../Components/policyterms";
const privacyData = [
  {
    title: "1. Introduction",
    content: "Welcome to Best Bosses! This Privacy Policy outlines how we collect, use, disclose, and protect your personal information when you use our website and services. By accessing or using Best Bosses, you agree to the practices described in this policy."
  },
  {
    title: "2. Information We Collect",
    content: [
      "a. User-Provided Information: When you use Best Bosses, we may collect information you provide to us, such as your name, email address, and other personal details.",
      "b. Automatically Collected Information: We may also collect certain information automatically when you use our website, such as your IP address, device information, and usage data."
    ]
  },
  {
    title: "3. How We Use Your Information",
    content: [
      "We may use the information collected for the following purposes:",
      "a. To provide and improve our services.",
      "b. To communicate with you, respond to your inquiries, and send you updates.",
      "c. To personalize your experience and deliver relevant content.",
      "d. To analyze usage patterns and improve our website."
    ]
  },
  {
    title: "4. Sharing Your Information",
    content: [
      "We may share your information with third parties, including:",
      "a. Service providers who assist us in operating the website.",
      "b. With your consent.",
      "c. As required by law or to protect our rights."
    ]
  },
  {
    title: "5. Security",
    content: "We take reasonable measures to protect your personal information, but no method of transmission over the internet or electronic storage is 100% secure. We cannot guarantee the security of your data."
  },
  {
    title: "6. Your Choices",
    content: "You can control the information you provide to us. You can update or delete your account information at any time. You can also unsubscribe from our communications."
  },
  {
    title: "7. Cookies and Tracking Technologies",
    content: "We use cookies and similar technologies to collect information about your usage of our website. You can control cookies through your browser settings."
  },
  {
    title: "8. Third-Party Links",
    content: "Our website may contain links to third-party websites. We are not responsible for the privacy practices of these websites. Please review their privacy policies."
  },
  {
    title: "9. Children's Privacy",
    content: "Best Bosses is not intended for children under 13. We do not knowingly collect personal information from children."
  },
  {
    title: "10. Changes to this Policy",
    content: "We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the 'Last Updated' date will be modified accordingly."
  }
];

const PrivacyPolicy = () => {
  return (
    <div style={{
      backgroundColor: "#F5F6FE",
      width: "100%",
      fontFamily:"Urbanist",
      padding: "48px 0",
    }}>
      <h1 style={{
        textAlign: "center",
        fontSize: "4rem",
        fontWeight: "bold",
        fontFamily:"Urbanist",
        color: "#181C23",
        marginBottom: "0.35rem",
        lineHeight: "1.2"
      }}>
        Privacy Policy
      </h1>
      <p style={{ 
        textAlign: "center", 
        marginBottom: "2.5rem", 
        fontSize: "1rem", 
        color: "#181C23", 
        fontWeight: "500" 
      }}>
        Last Updated: June 03, 2025
      </p>
      <div style={{
        width: "90%",
        maxWidth: "1200px",
        margin: "2.5rem auto 0",
        display: "flex",
        flexDirection: "column",
        gap: "1.25rem",
        backgroundColor: "#F5F6FE",
      }}>
        {privacyData.map((section, index) => (
          <PolicyTermsPage 
            key={index}
            title={section.title}
            content={section.content}
            isLast={index === privacyData.length - 1}
          />
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicy;